/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { Auth } from 'aws-amplify';
import WoocommerceAPi from 'woocommerce';
import {
  Table, PageHeader, Typography, Row, Space, Button, Modal, Result
} from 'antd';
import _ from 'lodash';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Breadcrumb from 'components/BreadCrumb';
import TableWrapper from 'styles/TableWrapper';
import { washersCompatiblePerConnection } from 'containers/specifications/constants';
import Spinner from 'components/Spins/Basic';
import { saveOrder } from 'utils/orders';
import { getUserId } from 'utils/wordpress';
import { sendSpecification } from 'utils/mails';
import { getProductCode } from 'utils/codes';
import ModalForm from 'containers/mailing/ModalFrom';
import SendCDC from 'containers/mailing/SendCDC';
import DownLoadPDF from 'components/pdf/download';
import { createWordpressPreOrder } from '../../../wordpress';
import OrderModal from 'containers/orders/proposals/components/OrderModal';

const { Column } = Table;
const { Title, Text, Paragraph } = Typography;

const Proposal = props => {
  const { location: { state }, history: { replace } } = props;
  const [loading, setLoading] = useState(false);
  const [OrderLoading, setOrderLoading] = useState(false);
  const [connections, setConnections] = useState([]);
  const [washers, setWashers] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isOrderModalVisible, setIsOrderModalVisible] = useState(false);
  const [isConfirmModalVisible, setIsConfirmModalVisible] = useState(false);
  const [isSendCdcModalVisible, setIsSendCdcModalVisible] = useState(false);
  const [totalHT, setTotalHT] = useState(false);
  const [orderStatus, setOrderStatus] = useState('success');
  const [orderModalTitle, setOrderModalTitle] =
    useState('Vous allez être rediriger vers notre site e-commerce pour finaliser la commande')
  const [orderModalSubTitle, setOrderModalSubTitle] =
    useState('Munissez-vous des mêmes identifiants que ceux du calculateur.')

  const showConfirmModal = () => {
    setIsConfirmModalVisible(true);
  };

  const handleConfirmOk = () => {
    setIsConfirmModalVisible(false);
    setIsOrderModalVisible(false);
  };

  const handleConfirmCancel = () => {
    setIsConfirmModalVisible(false);
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsSendCdcModalVisible(false);
    setIsModalVisible(false);
    setIsOrderModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setIsOrderModalVisible(false);
  };

  const { specification, chosenProduct, recipe, flexible, newSpecificationSavedId, crimping } = state;

  useEffect(() => {
    WoocommerceAPi.get('products', { per_page: 99, category: 164 })
      .then((woocommerceConnection) => {
        setConnections(woocommerceConnection);
      })
      .catch(err => {
        console.error(err);
      });
    WoocommerceAPi.get('products', { per_page: 99, category: 170 })
      .then((woocommerceWasher) => {
        setWashers(woocommerceWasher);
      })
      .catch(err => {
        console.error(err);
      });
  }, []);

  const getConnections = (connection) => {
    if (_.isEmpty(connections)) return false;
    return (
      connections.data.filter(con => con.sku === connection)
    );
  };

  const getWashers = (rDiameter, color, qty) => {
    if (_.isEmpty(washers)) return false;
    let product = '';
    const filtered = washersCompatiblePerConnection.filter(washer => washer.connections.includes(rDiameter));
    if (!_.isEmpty(filtered) && color) {
      const productCode = filtered[0][color];
      // eslint-disable-next-line prefer-destructuring
      product = washers.data.filter(wc => wc.sku === productCode);
      if (!_.isEmpty(product[0])) {
        product[0].quantity = qty;
      }
    }
    return product;
  };

  const getTableDatasource = (showPieces=false, toJson=false) => {
    const datasource = [];
    const jsonWrapper = {};
    const {
      r1Diameter, r2Diameter, r1asherNumber, r2asherNumber, r1WasherColor, r2WasherColor
    } = specification;
    chosenProduct[0].quantity = (specification.length / 1000);
    chosenProduct[0].unity = "mètre(s)";

    const productCode = (_.filter(chosenProduct[0].meta_data, { key: 'code' }))[0].value;

    if (showPieces) {
      datasource['flexible'] = chosenProduct[0];
    } else if(toJson) {
      jsonWrapper.flexible = {
        id: chosenProduct[0].id,
        quantity: chosenProduct[0].quantity
      };
    } else {
      datasource.push(chosenProduct[0]);
    }
    const r1 = getConnections(r1Diameter);
    if (r1 && !_.isEmpty(r1)) {
      r1[0].quantity = 1;
      r1[0].unity = "pièce(s)";
      if (showPieces) {
        datasource['r1'] = r1[0];
      } else if(toJson) {
        jsonWrapper.r1 = {
          id: r1[0].id,
          quantity: r1[0].quantity
        };
      } else {
        datasource.push(r1[0]);
      }
    }
    const r2 = getConnections(r2Diameter);
    if (r2 && !_.isEmpty(r2)) {
      r2[0].quantity = 1;
      r2[0].unity = "pièce(s)";
      if (showPieces) {
        datasource['r2'] = r2[0];
      } else if(toJson) {
        jsonWrapper.r2 = {
          id: r2[0].id,
          quantity: r2[0].quantity
        };
      } else {
        datasource.push(r2[0]);
      }
    }
    if (r1asherNumber > 0) {
      const w1 = getWashers(productCode, r1WasherColor, r1asherNumber);
      if (w1 && !_.isEmpty(w1)) {
        w1[0].unity = "pièce(s)";
        if (showPieces) {
          datasource['w1'] = w1[0];
        } else if(toJson) {
          jsonWrapper.w1 = {
            id: w1[0].id,
            quantity: w1[0].quantity
          };
        } else {
          datasource.push(w1[0]);
        }
      }
    }
    if (r2asherNumber > 0) {
      const w2 = getWashers(productCode, r2WasherColor, r2asherNumber);
      if (w2 && !_.isEmpty(w2)) {
        w2[0].unity = "pièce(s)";
        if (showPieces) {
          datasource['w2'] = w2[0];
        } else if(toJson) {
          jsonWrapper.w2 = {
            id: w2[0].id,
            quantity: w2[0].quantity
          };
        } else {
          datasource.push(w2[0]);
        }
      }
    }
    const crimp = crimping;
    crimp.quantity = 1;
    crimp.unity = "pièce(s)";
    if (showPieces) {
      datasource['certissage'] = crimp;
    } else if(toJson) {
      jsonWrapper.crimping = {
        id: crimping.id,
        quantity: crimping.quantity
      };
    } else {
      datasource.push(crimp);
    }

    if(toJson) {
      return jsonWrapper;
    }
    return datasource;
  };

  const handleCreateWordpressPreOrder = async () => {
      setOrderLoading(true);
      const { attributes } = await Auth.currentAuthenticatedUser();
      const { email } = attributes;
      const products = getTableDatasource(false, true);
      if (email) {
        const post = {
          title: specification?.name,
          acf: {
            titre_de_la_recette: recipe?.name,
            simulants: JSON.stringify(specification),
            produits: JSON.stringify(products),
            identifiant_utilisateur: email,
            titre_cahier_des_charges: specification?.name,
          },
        }
        try {
          const order = await createWordpressPreOrder(post);
          await onFinalizeOrder(email, order?.id);
        } catch (e) {
          // si erreur ici
          console.error(e.toString())
          onOrderFailed();
        }
      }
  }

  const handleSaveOrder = async (showOrders) => {
    const productList = getTableDatasource();
    let res = {};
    try {
      const item = {
        specificationId: newSpecificationSavedId,
        products: productList,
        totalHT: totalHT
      }
      const newOrder = await saveOrder(item);
      if (newOrder?.data.createOrder?.id) {
        res = newOrder?.data.createOrder?.id;
        if(showOrders) {
          replace('/orders');
        }
      }
    } catch (e) {
      setIsModalVisible(true);
    }
    return res;
  }

  const onFinish = async result => {
    await handleSaveOrder(false);
    const products = getTableDatasource(true);
    setLoading(true);
    await sendSpecification(recipe, specification, result, products);
    setLoading(false);
    setIsSendCdcModalVisible(false);
    setIsConfirmModalVisible(true);
  };

  const onFinalizeOrder = async (email, orderId) => {
    setOrderLoading(false);
    setIsOrderModalVisible(true);
    await handleSaveOrder(false);
    setTimeout(function() {
      const url = encodeURI(`https://www.flex-key.com/finalisation-commande?orderId=${orderId}`)
      window.location.replace(url);
    }, 2000)
  }

  const onOrderFailed = () => {
    setOrderLoading(false);
    setOrderModalTitle('Erreur de la création de votre commande');
    setOrderModalSubTitle('');
    setOrderStatus('error')
    setIsOrderModalVisible(true);
  }

  const getContent = () => {
    const data = getTableDatasource();
    if (_.isEmpty(data)) return false;
    const products = getTableDatasource(true);

    return (
      <TableWrapper>
        <Title level={2} style={{ textAlign: 'center' }}>Vos produits</Title>
        <Table
          style={{ marginTop: '40px' }}
          dataSource={data}
          scroll={{ x: true }}
          pagination={false}
          summary={pageData => {
            let total = 0;

            pageData.forEach(({ price, quantity }) => {
              total += parseFloat(price) * quantity;
            });
            setTotalHT(total);
            return (
              <Table.Summary.Row>
                <Table.Summary.Cell></Table.Summary.Cell>
                <Table.Summary.Cell>Total</Table.Summary.Cell>
                <Table.Summary.Cell>{total.toFixed(2)}</Table.Summary.Cell>
                <Table.Summary.Cell>€ HT <Text type="danger">*</Text></Table.Summary.Cell>
              </Table.Summary.Row>
            )
          }}
        >
          <Column title="Code produit" dataIndex="sku" key="sku" />
          <Column title="Nom" dataIndex="name" key="name" />
          <Column
            title="Quantité"
            key="quantity"
            render={(record) => record?.quantity || 1}
          />
          <Column title="Unité" dataIndex="unity" key="unity" />
        </Table>
        <Row>
          <Paragraph style={{ width: '100%', textAlign: 'right', marginTop: '10px' }}>
            <Text type="danger">*</Text> Hors livraison et frais d'emballage</Paragraph>
        </Row>
        <Row justify="center" type="flex">
          <Space wrap align="start" size="large" style={{ marginTop: '20px' }}>
            <DownLoadPDF
              recipeIngredient={recipe?.ingredients}
              detailsSpecification={specification}
              id={specification.name}
              recipe={recipe.name}
              products={products}
            />
            <Button type="primary" onClick={() => setIsSendCdcModalVisible(true)}>Demander un devis</Button>
            {/*<Button type="primary" size="large" onClick={handleSaveOrder}>Enregistrer le document</Button>*/}
            <Button type="primary" onClick={handleCreateWordpressPreOrder} loading={OrderLoading}>Passer commande</Button>
          </Space>
        </Row>
      </TableWrapper>
    );
  };

  const getContentOrSpinner = () => {
    if (_.isEmpty(connections) && _.isEmpty(washers)) {
      return (
        <>
          <h4>Chargement de produits</h4>
          <Spinner size="large" />
        </>
      );
    }
    return getContent();
  };

  return (
    <>
      <OrderModal
        visible={isOrderModalVisible}
        status={orderStatus}
        title={orderModalTitle}
        subTitle={orderModalSubTitle}
        handleOk={handleOk}
      />
      <Modal title="Problème" visible={isModalVisible} onOk={handleOk} onCancel={handleCancel}>
        <Result
          status="warning"
          title="Impossible d'enregistrer votre documents"
        />
      </Modal>
      <Modal
        title="Félicitation"
        visible={isConfirmModalVisible}
        onOk={handleConfirmOk}
        footer={[
          <Button key="submit" type="primary" onClick={handleConfirmOk}>
            Fermer
          </Button>,
        ]}
      >
        <Result
          status="success"
          title="Votre devis a été envoyé. Notre équipe vous contactera rapidement."
        />
      </Modal>
      <PageHeader
        style={{ border: '1px solid #d9d9d9' }}
        title="Chiffrage"
        breadcrumb={(
          <Breadcrumb
            items={[
              ['Accueil', '/'],
              ['Chiffrage'],
            ]}
          />
        )}
      />
      <InnerContent>
        <ModalForm
          Form={SendCDC}
          onFinish={onFinish}
          handleOk={handleOk}
          isModalVisible={isSendCdcModalVisible}
          loading={loading}
        />
        {getContentOrSpinner()}
      </InnerContent>
    </>
  );
};

const InnerContent = styled.div`
  background: #fff;
  margin: 0px;
  margin-top: 20px;
`;

Proposal.propTypes = {
  history: PropTypes.shape({
    replace: PropTypes.func
  }),
  location: PropTypes.shape({
    state: PropTypes.shape({
      recipe: PropTypes.shape({
        name: PropTypes.string,
        userId: PropTypes.string,
        ingredients: PropTypes.shape({
          condition: PropTypes.string,
          ingredient: PropTypes.string,
          themes: PropTypes.string
        })
      }),
      specification: PropTypes.shape({}),
      value: PropTypes.shape({
        productId: PropTypes.string,
      }),
      chosenProduct: PropTypes.shape({})
    })
  })
};

export default Proposal;
